import React, { useMemo } from 'react';
import { useFormikContext } from 'formik';
import { Button, Container, Grid, Message } from 'semantic-ui-react';
import { EEhsStatus, ehsStatusMap, EUserLevels, IAttivitaAltoRischio, IEhs, IUser } from '@relab/alstom-ptw-shared';
import { EhsStatusButton } from './EhsStatusButton';
import { InputWithoutEnter } from '../../../InputWithoutEnter';
import { TranslationComponent } from '../../../TranslationComponent';
import { useTranslation } from 'react-i18next';
import { EhsDeleteModal } from '../../EhsDeleteModal';

interface EhsHeadlineComponentProps {
  ehs: IEhs;
  onCancel: () => void;
  onDelete?: () => void;
  requestError?: string;
  user: IUser;
}

export const EhsHeadlineComponent: React.FC<EhsHeadlineComponentProps> = ({
  ehs,
  onCancel,
  onDelete,
  requestError,
  user,
}) => {
  const { t } = useTranslation();
  const { values, initialValues, setFieldValue, errors, touched, validateForm } = useFormikContext<IEhs>();

  const handleStatusButtonClick = async (ehsStatus: EEhsStatus) => {
    if (values.attivitaAltoRischio.includes(IAttivitaAltoRischio.lavoriACaldo)) {
      setFieldValue('approvazioneLavoriACaldo.name', values.approvazioneLavoriACaldo?.name ?? '', true);
      setFieldValue('approvazioneLavoriACaldo.sign', values.approvazioneLavoriACaldo?.sign ?? null, true);
    }

    const errors = await validateForm();
    if (Object.keys(errors).length === 0) {
      setFieldValue('status', ehsStatus);
    }
  };

  const deletionAllowance = useMemo(
    () =>
      onDelete &&
      (user.userLevel === EUserLevels.Admin ||
        (ehs.status === EEhsStatus.NUOVO && (ehs.issuer as IUser)?._id === user._id)),
    [onDelete, ehs.issuer, ehs.status, user._id, user.userLevel]
  );

  return (
    <Grid container>
      <Grid.Row stretched columns={3}>
        <Grid.Column>
          <InputWithoutEnter name="name" label={t('Titolo PTW EHS')} />
        </Grid.Column>

        <Grid.Column>
          <div>
            <TranslationComponent stringKey={'Status: {{name}}'} values={{ name: ehsStatusMap[values.status].name }} />
          </div>

          {ehs.issuer && <div>Author: {ehs.issuer.name}</div>}
        </Grid.Column>

        <Grid.Column>
          <Grid>
            <Grid.Row columns={2}>
              <Grid.Column>
                <Button fluid type={'button'} onClick={onCancel}>
                  <TranslationComponent stringKey={'Cancel'} />
                </Button>

                {deletionAllowance && <EhsDeleteModal onDelete={onDelete} detailScreen error={requestError} />}
              </Grid.Column>

              <Grid.Column>
                <Container style={{ display: 'flex', justifyContent: 'flex-end' }}>
                  <EhsStatusButton
                    ehsStatus={initialValues.status}
                    onclick={handleStatusButtonClick}
                    ehs={ehs}
                    userLevel={user.userLevel}
                    userRoles={user.userRoles}
                  />
                </Container>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Grid.Column>
      </Grid.Row>

      <Grid.Row stretched columns={3}>
        <Grid.Column />
        <Grid.Column />
        <Grid.Column>
          {Object.keys(touched).length >= Object.keys(errors).length && Object.keys(errors).length > 0 && (
            <Message error visible>
              <TranslationComponent stringKey={'Ci sono alcuni errori da risolvere'} />
            </Message>
          )}
        </Grid.Column>
      </Grid.Row>
    </Grid>
  );
};
